const URL = "/api/v3/floorplans/all/";

export function fetch(apiKey) {
    let url = `${URL}?api_key=${apiKey}&show_all_units=True`;

    return new Promise(function(resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.addEventListener("load", function() {
            let data = JSON.parse(this.responseText);
            resolve(data);
        });
        xhr.addEventListener("error", function() {
            reject(new Error(`failed to fetch url: ${url}`));
        });
        xhr.open("GET", url, true);
        xhr.send();
    });
};
